import { IconPropsType } from '..';

export const AttachFileIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.50176 11.327V9.88472H11.1368C11.6194 9.88472 12.0823 9.69299 12.4235 9.35171C12.7648 9.01043 12.9565 8.54756 12.9565 8.06492C12.9565 7.58228 12.7648 7.11941 12.4235 6.77813C12.0823 6.43685 11.6194 6.24512 11.1368 6.24512H8.50176V4.80285H11.1368C12.0022 4.80285 12.8323 5.14667 13.4443 5.75866C14.0563 6.37066 14.4001 7.20071 14.4001 8.0662C14.4001 8.93169 14.0563 9.76174 13.4443 10.3737C12.8323 10.9857 12.0022 11.3295 11.1368 11.3295L8.50176 11.327ZM4.86344 11.327C3.99795 11.327 3.16791 10.9832 2.55591 10.3712C1.94391 9.75918 1.6001 8.92913 1.6001 8.06364C1.6001 7.19815 1.94391 6.3681 2.55591 5.75611C3.16791 5.14411 3.99795 4.80029 4.86344 4.80029H7.49844V6.24512H4.86344C4.3808 6.24512 3.91793 6.43685 3.57665 6.77813C3.23538 7.11941 3.04365 7.58228 3.04365 8.06492C3.04365 8.54756 3.23538 9.01043 3.57665 9.35171C3.91793 9.69299 4.3808 9.88472 4.86344 9.88472H7.49844V11.327H4.86344ZM5.3651 8.81741V7.31243H10.6351V8.81741H5.3651Z"
      fill="#6D7483"
    />
  </svg>
);
